// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabs_tab__2LVIU","single":"tabs_single__eM6bh","smalltab":"tabs_smalltab__1_zzU","active":"tabs_active__101BC","bar":"tabs_bar__1rx7D","smallbar":"tabs_smallbar__3LJfA"};